export const OWNER_VAULT_CATEGORIES = [
    { 'value': 'deeds', 'label': 'Deeds', 'icon': 'bi-file-earmark-text' },
    { 'value': 'warranties', 'label': 'Warranties', 'icon': 'bi-patch-check' },
    { 'value': 'insurance', 'label': 'Insurance', 'icon': 'bi-shield-check' },
    { 'value': 'tax', 'label': 'Tax Documents', 'icon': 'bi-receipt' },
    { 'value': 'inspection', 'label': 'Inspection Reports', 'icon': 'bi-search' },
    { 'value': 'receipts', 'label': 'Receipts & Invoices', 'icon': 'bi-card-list' },
    { 'value': 'permits', 'label': 'Permits', 'icon': 'bi-clipboard-check' },
    { 'value': 'other', 'label': 'Other', 'icon': 'bi-folder' },
];
export const ownerVaultCategoryMeta = (value) => {
    var _a;
    return (_a = OWNER_VAULT_CATEGORIES.find((category) => category.value === value)) !== null && _a !== void 0 ? _a : OWNER_VAULT_CATEGORIES[OWNER_VAULT_CATEGORIES.length - 1];
};
